module.exports = __webpack_public_path__ + "static/media/retail-property-grid-2.3ecb3604.jpeg";